export const GLOBALS = {
  borderRadius: "6px",
  transition: "200ms",
  mobileDeviceWidth: "768px",
  wideMobileDeviceWidth: "890px",
};
